var _rect, _rect2, _rect3, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatureReschedule(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 31,
    height: 31,
    rx: 2,
    stroke: "#00AAE5",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 31,
    width: 43,
    height: 43,
    rx: 4,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 37,
    width: 41,
    height: 41,
    rx: 2,
    stroke: "#263346",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.6758 47C60.5233 47.0051 63.1086 48.1272 65.0174 49.9513L66.552 48.4167C67.2017 47.7671 68.3125 48.2272 68.3125 49.1459V54.9063C68.3125 55.4758 67.8508 55.9375 67.2812 55.9375H61.5209C60.6021 55.9375 60.142 54.8267 60.7917 54.177L62.5856 52.3831C61.2594 51.1413 59.5434 50.4535 57.7203 50.4378C53.75 50.4035 50.4034 53.6165 50.4378 57.7185C50.4703 61.6098 53.6251 64.875 57.6562 64.875C59.4234 64.875 61.0936 64.2443 62.4098 63.0894C62.6136 62.9106 62.9214 62.9215 63.1132 63.1132L64.8174 64.8174C65.0267 65.0267 65.0164 65.368 64.7967 65.5665C62.9071 67.2732 60.4031 68.3125 57.6562 68.3125C51.771 68.3125 47 63.5416 47 57.6564C47 51.7778 51.7973 46.9895 57.6758 47Z",
    fill: "#00AAE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5272 27.9991L34.1817 23.3554C34.3855 23.1516 34.5 22.8751 34.5 22.5869C34.5 22.2986 34.3855 22.0222 34.1817 21.8183C33.9778 21.6145 33.7014 21.5 33.4131 21.5C33.1249 21.5 32.8484 21.6145 32.6446 21.8183L28.0009 26.4728L23.3573 21.8183C23.1534 21.6145 22.877 21.5 22.5887 21.5C22.3005 21.5 22.024 21.6145 21.8202 21.8183C21.6164 22.0222 21.5018 22.2986 21.5018 22.5869C21.5018 22.8751 21.6164 23.1516 21.8202 23.3554L26.4747 27.9991L21.8202 32.6427C21.7187 32.7434 21.6382 32.8631 21.5832 32.995C21.5283 33.1269 21.5 33.2684 21.5 33.4113C21.5 33.5542 21.5283 33.6957 21.5832 33.8276C21.6382 33.9595 21.7187 34.0792 21.8202 34.1798C21.9208 34.2813 22.0405 34.3618 22.1724 34.4168C22.3043 34.4717 22.4458 34.5 22.5887 34.5C22.7316 34.5 22.8731 34.4717 23.005 34.4168C23.1369 34.3618 23.2566 34.2813 23.3573 34.1798L28.0009 29.5253L32.6446 34.1798C32.7452 34.2813 32.8649 34.3618 32.9968 34.4168C33.1288 34.4717 33.2702 34.5 33.4131 34.5C33.556 34.5 33.6975 34.4717 33.8294 34.4168C33.9613 34.3618 34.081 34.2813 34.1817 34.1798C34.2831 34.0792 34.3636 33.9595 34.4186 33.8276C34.4736 33.6957 34.5018 33.5542 34.5018 33.4113C34.5018 33.2684 34.4736 33.1269 34.4186 32.995C34.3636 32.8631 34.2831 32.7434 34.1817 32.6427L29.5272 27.9991Z",
    fill: "#00AAE5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureReschedule);
export default __webpack_public_path__ + "static/media/feature-reschedule.1de11a16.svg";
export { ForwardRef as ReactComponent };